// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import ta from "./locales/ta.json";

const fallbackLng = "en";
const savedLng = localStorage.getItem("i18nextLng") || null;

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ta: { translation: ta },
    },
    lng: savedLng || "ta",           
    fallbackLng,
    interpolation: { escapeValue: false },
    detection: {
    }
  });

export default i18n;
